import { render, staticRenderFns } from "./Password.vue?vue&type=template&id=3ddc3f2c&scoped=true"
import script from "./Password.vue?vue&type=script&lang=js"
export * from "./Password.vue?vue&type=script&lang=js"
import style0 from "./Password.vue?vue&type=style&index=0&id=3ddc3f2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddc3f2c",
  null
  
)

export default component.exports